// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__0ImAW","contentWrapper":"styles_contentWrapper___BxGO","content":"styles_content__yaoV5"};